import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../main/main.styles';
import { scrollbarStyles } from '../../../styles';

export const KnowledgeBlockModalStyles = css`
  ${MainStyles}
  ${scrollbarStyles}
    .knowledge-block-modal-wrapper {
    padding: 0px 0px 16px 16px;
    width: auto;
    font-size: 12px;
    color: rgb(184, 184, 184);
    text-align: justify;
    display: flex;
    height: calc(100% - 58px);
  }

  .knowledge-block-modal-content-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow-y: auto;
  }

  .knowledge-block-modal-content {
    padding-right: 10px;
  }

  a {
    color: white;
  }

  .title {
    color: var(--primary-color);
  }
  .item {
    color: white;
    font-size: 16px;
  }

  .definition {
    font-size: 12px;
  }

`;
